import { WalletBase as n, WalletEvents as a } from "../types/index.mjs";
class i extends n {
  // @ts-expect-error, it is temporarily being ignored
  connected;
  address;
  ethereum;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  accountChangedCallback;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  chainChangedCallback;
  constructor() {
    super(), this.ethereum = window.BinanceChain;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isSupported() {
    return this.ethereum;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  isConnected() {
    return this.connected;
  }
  getAddress() {
    return this.address;
  }
  install() {
    window.open(
      "https://chrome.google.com/webstore/detail/binance-wallet/fhbohimaelbohpjbbldcngcnapndodjp"
    );
  }
  // @ts-expect-error, it is temporarily being ignored
  setOnAccountChangedCallback(e) {
    this.accountChangedCallback = e;
  }
  // @ts-expect-error, it is temporarily being ignored
  setOnChainChangedCallback(e) {
    this.chainChangedCallback = e;
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listenerCallback(e, t) {
    switch (e) {
      case a.accountsChanged: {
        this.accountChangedCallback !== void 0 && this.accountChangedCallback(t);
        break;
      }
      case a.chainChanged: {
        this.chainChangedCallback !== void 0 && this.chainChangedCallback(t);
        break;
      }
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async connect() {
    if (this.isSupported() === void 0)
      this.install();
    else {
      [
        a.accountsChanged,
        a.chainChanged,
        a.connect,
        a.disconnect,
        a.message
      ].forEach((t) => {
        this.ethereum.on(t, (s) => {
          this.listenerCallback(t, s);
        });
      });
      const e = await this.ethereum.request({
        method: "eth_requestAccounts"
      });
      return (this.address == null || this.address === "") && this.listenerCallback(a.accountsChanged, e), Array.isArray(e) && e.length > 0 && (this.address = e[0]), this.connected = !0, this.address;
    }
  }
  disconnect() {
    this.address = void 0, this.accountChangedCallback = void 0, this.connected = !1;
  }
  // Use MetaMask to send a generic transaction. The data parameter needs to be encoded with ABI for contract method.
  // params: { from, to, data }
  // @ts-expect-error, it is temporarily being ignored
  sendTx(e) {
    return this.ethereum.request({
      method: "eth_sendTransaction",
      params: [e]
    });
  }
  // Currently has a bug, unable to wait for user selection: https://github.com/MetaMask/metamask-extension/issues/12416
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  addToken(e) {
    return Promise.resolve("");
  }
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async switchChain(e) {
    const { chainId: t } = e;
    return await this.ethereum.switchNetwork(t);
  }
}
export {
  i as default
};
//# sourceMappingURL=binanceChain.mjs.map
